/* No Pain Numb theme — front-end behaviour.
   Ported from the prototype's site.js, with the cart rewired to Shopify's AJAX Cart API
   (/cart/add.js, /cart/change.js, /cart.js). Header, footer and cart drawer markup are
   rendered by Liquid sections/snippets; this file only drives interaction. */
(function () {
  var routes = window.NPN_ROUTES || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' };

  function money(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  // Cart-drawer upsell: recommends complementary products for the first item in the bag.
  function renderUpsell(cart) {
    var el = document.querySelector('[data-drawer-upsell]');
    if (!el) return;
    if (!cart.items.length) { el.innerHTML = ''; return; }
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    var pid = cart.items[0].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var recs = (j.products || []).filter(function (p) { return !inCart[p.id] && p.available !== false; }).slice(0, 2);
        if (!recs.length) { el.innerHTML = ''; return; }
        el.innerHTML = '<p class="meta" style="color:var(--blue);padding:16px 24px 4px">Before you go</p>' + recs.map(function (p) {
          var v = p.variants && p.variants[0] ? p.variants[0].id : null;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          return '<div class="ci" style="padding:12px 24px"><div class="ci__img"><img src="' + img + '" alt="' + p.title + '"></div>' +
            '<div><div class="h2s" style="font-size:14px">' + p.title + '</div><div class="cap">' + money(p.price) + '</div></div>' +
            (v ? '<button class="btn btn--sm" data-add="' + v + '">Add</button>' : '') + '</div>';
        }).join('');
      }).catch(function () { el.innerHTML = ''; });
  }

  var Cart = {
    openEl: function () { return document.querySelector('.drawer'); },
    open: function () {
      var d = document.querySelector('.drawer'), s = document.querySelector('.scrim');
      if (d) d.classList.add('on'); if (s) s.classList.add('on');
    },
    close: function () {
      var d = document.querySelector('.drawer'), s = document.querySelector('.scrim');
      if (d) d.classList.remove('on'); if (s) s.classList.remove('on');
    },
    get: function () { return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); },
    add: function (id, qty) {
      return fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { return Cart.render(); }).then(function () { Cart.open(); });
    },
    change: function (line, qty) {
      return fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () { return Cart.render(); });
    },
    render: function () {
      return Cart.get().then(function (cart) {
        var badge = document.querySelector('.cartbtn b'),
            btn = document.querySelector('.cartbtn'),
            tot = document.querySelector('[data-cart-total]'),
            body = document.querySelector('.drawer__b'),
            checkout = document.querySelector('[data-checkout]');
        if (badge) badge.textContent = cart.item_count;
        if (btn) btn.classList.toggle('has', cart.item_count > 0);
        if (tot) tot.textContent = money(cart.total_price);
        renderUpsell(cart);
        if (!body) return cart;
        if (!cart.items.length) {
          body.innerHTML = '<div style="padding:60px 0;text-align:center"><p class="display d-s">Nothing numb yet.</p><p class="small dim mt-s">Free UK postage on every order.</p><a class="btn btn--line btn--sm mt" href="/collections/all">Shop the range</a></div>';
          if (checkout) checkout.setAttribute('disabled', '');
          return cart;
        }
        if (checkout) checkout.removeAttribute('disabled');
        body.innerHTML = cart.items.map(function (it, i) {
          var img = it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_120x$1') : '';
          return '<div class="ci"><div class="ci__img"><img src="' + img + '" alt="' + it.product_title + '"></div>' +
            '<div><div class="h2s" style="font-size:15px">' + it.product_title + '</div>' +
            '<div class="cap">' + money(it.final_price) + '</div>' +
            '<div class="qty mt-s" data-line="' + (i + 1) + '"><button data-d="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity + '</span><button data-d="1" aria-label="Increase">+</button></div></div>' +
            '<button class="x" data-rm="' + (i + 1) + '" data-q="' + it.quantity + '" aria-label="Remove">&times;</button></div>';
        }).join('');
        return cart;
      });
    }
  };
  window.NPNCart = Cart;

  document.addEventListener('DOMContentLoaded', function () {
    Cart.render();

    document.addEventListener('click', function (e) {
      var t = e.target;

      if (t.closest('[data-open-cart]')) { e.preventDefault(); Cart.open(); }
      if (t.closest('[data-close-cart]')) Cart.close();

      // Add to cart (data-add = variant id)
      var add = t.closest('[data-add]');
      if (add) {
        e.preventDefault();
        var id = add.getAttribute('data-add');
        if (id) {
          Cart.add(id, parseInt(add.getAttribute('data-qty') || '1', 10));
          var label = add.getAttribute('data-label');
          if (label === null) { var o = add.textContent; add.textContent = 'Added'; setTimeout(function () { add.textContent = o; }, 1400); }
        }
      }

      // Remove line
      var rm = t.closest('[data-rm]');
      if (rm) Cart.change(parseInt(rm.getAttribute('data-rm'), 10), 0);

      // Quantity +/-
      var q = t.closest('.qty button');
      if (q) {
        var wrap = q.closest('[data-line]');
        var line = parseInt(wrap.getAttribute('data-line'), 10);
        var cur = parseInt(wrap.querySelector('span').textContent, 10);
        Cart.change(line, cur + parseInt(q.getAttribute('data-d'), 10));
      }

      // Burger menu
      var b = t.closest('[data-burger]');
      if (b) { var n = document.getElementById('nav'); n.classList.toggle('on'); b.setAttribute('aria-expanded', n.classList.contains('on')); }

      // Accordion
      var acc = t.closest('.acc__q');
      if (acc) { var it = acc.parentElement, a = it.querySelector('.acc__a'), open = it.classList.toggle('open'); a.style.maxHeight = open ? a.scrollHeight + 'px' : 0; }
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });

    // Reveal on scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.rv').forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 60 + 'ms'; io.observe(el); });

      // Sticky add-to-cart bar
      var satc = document.querySelector('.satc'), anchor = document.querySelector('[data-satc-after]');
      if (satc && anchor) new IntersectionObserver(function (es) {
        satc.classList.toggle('on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    } else {
      document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
    }
  });
})();
